import { FC } from 'react'
import { KudosDto } from '../../../types'
import { PerModal } from '../Modal'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { useDateTime } from '../../../shared/useDateTime'
import { useAuth } from '../../../context/auth-context'
import { NameDisplayPreference } from '../../../graphql/enum/name-display-preference.enum'
import { PerAvatarPlus } from '../AvatarPlus'
import PerIcon from '../Icon'
import { useTranslation } from 'react-i18next'
import { getKudosColor } from '../../../shared/kudosUtil'

export interface KudosDetailsModalProps {
  visible: boolean
  onClose: () => void
  kudos: KudosDto
}

export const KudosDetailsModal: FC<KudosDetailsModalProps> = ({ visible, onClose, kudos }) => {
  const { user } = useAuth()
  const { t } = useTranslation()

  const { formatDateShort } = useDateTime(user)

  return (
    <PerModal
      title={{
        heading: t('kudos.detailsModal.title'),
      }}
      size="medium"
      centered
      visible={visible}
      onCancel={onClose}
      footer={{
        confirmBtn: {
          onClick: onClose,
          altText: t('kudos.detailsModal.closeButtonText'),
        },
      }}
    >
      <PerFlexRow direction="column">
        {kudos.author && kudos.employee && (
          <PerFlexRow align="bottom">
            {/* From Section */}
            <div style={{ maxWidth: '44%' }}>
              <PerFlexRow direction="column" justify="start" mr="xxl">
                <PerText fontSize="s" color="secondary" mb="xxxs">
                  {t('global.from')}
                </PerText>
                {kudos.authorId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
                <PerAvatarPlus
                  firstName={kudos.author.firstName}
                  lastName={kudos.author.lastName}
                  nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
                  infoText={kudos.author.companyName}
                  nameType={kudos.authorId === user.employeeId ? 'you' : 'fullName'}
                />
                {kudos.authorId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
              </PerFlexRow>
            </div>

            {/* Arrow Section */}
            <div style={{ width: '12%', marginBottom: '2px' }}>
              <PerIcon name="arrowRight_stroke" size={18} color={getKudosColor(kudos.type)} />
            </div>

            {/* To Section */}
            <div style={{ maxWidth: '44%' }}>
              <PerFlexRow direction="column" justify="start">
                <PerText fontSize="s" color="secondary" mb="xxxs">
                  {t('global.to')}
                </PerText>
                {kudos.employeeId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
                <PerAvatarPlus
                  firstName={kudos.employee.firstName}
                  lastName={kudos.employee.lastName}
                  nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
                  infoText={kudos.employee.companyName}
                  nameType={kudos.employeeId === user.employeeId ? 'you' : 'fullName'}
                />
                {kudos.employeeId === user.employeeId && <div style={{ marginBottom: '2.5px' }}></div>}
              </PerFlexRow>
            </div>
          </PerFlexRow>
        )}

        <PerText fontSize="s" color="secondary" mt="l" mb="xxs">
          {formatDateShort(kudos.createdDate)}
        </PerText>
        <div style={{ minHeight: '100px' }}>
          <PerText>"{kudos.description}"</PerText>
        </div>
      </PerFlexRow>
    </PerModal>
  )
}

export default KudosDetailsModal
